// iosSupport.js

function userPlatform() {
  let sessionFlagship = JSON.parse(localStorage.getItem('sessionFlagship'))
  if (!localStorage.getItem('userPlatform')) {
    const platformInfo = {
      userAgent: navigator.userAgent,
      plataform: navigator.plataform,
      appName: navigator.appName,
      appVersion: navigator.appVersion,
      userPwaInstall: false,
      showPwaInfo: true,
      pwaAllowed: true,
      sessionId: 0
    }
    localStorage.setItem('userPlatform', JSON.stringify(platformInfo))
  }
  return JSON.parse(localStorage.getItem('userPlatform'))
}

function getUserPlatform() {
  return JSON.parse(localStorage.getItem('userPlatform'))
}

function checkIsPwa() {
  let userPlatform = getUserPlatform()
  if (window.matchMedia('(display-mode: standalone)').matches) {
    console.log('Application is running in standalone PWA mode')
    return true
  } else {
    console.log('Application is not in PWA mode.')
    userPlatform.showPwaInfo = true
    const updatedUserPlatform = JSON.stringify(userPlatform)
    localStorage.setItem('userPlatform', updatedUserPlatform)
    return false
  }
}

function getUserShowPwa() {
  let userPlatform = getUserPlatform()
  return userPlatform.showPwaInfo
}

function getUserPwaAllow() {
  let userPlatform = getUserPlatform()
  return userPlatform.pwaAllowed
}

function checkSessionId() {
  let userPlatform = getUserPlatform()
  let sessionFlagship = JSON.parse(localStorage.getItem('sessionFlagship'))
  userPlatform.sessionId === sessionFlagship.data.sessionId ? true : false
}

function pwaDenied() {
  let userPlatform = getUserPlatform()
  userPlatform.showPwaInfo = false
  userPlatform.pwaAllowed = false
  const updatedUserPlatform = JSON.stringify(userPlatform)
  localStorage.setItem('userPlatform', updatedUserPlatform)
  return userPlatform.showPwaInfo
}

export {
  userPlatform,
  checkIsPwa,
  getUserShowPwa,
  getUserPwaAllow,
  checkSessionId,
  pwaDenied
}
